import React, { useEffect, useState } from 'react';
import {
  Outlet,
  Link,
  useLocation,
  useNavigate
} from 'react-router-dom';

import axios from 'axios';

import {
  Container,
  Image,
  Nav,
  Navbar,
  NavDropdown
} from 'react-bootstrap';

import Banner from '../../images/banner.png';

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [avatarPath, setAvatarPath] = useState(null);

  // ✅ ตรวจสอบว่า JWT token หมดอายุหรือไม่
  const isTokenExpired = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp;
      if (!exp) return true;

      const currentTime = Math.floor(Date.now() / 1000);
      return exp < currentTime;
    } catch (e) {
      console.error('Invalid token', e);
      return true;
    }
  };

  useEffect(() => {
    const signed = localStorage.getItem('logged');

    // ถ้าไม่มีข้อมูลผู้ใช้ใน localStorage → กลับไป login
    if (!signed) {
      navigate('/login');
      return;
    }

    try {
      const logged = JSON.parse(signed);
      const token = logged?.user?.token;
      const userId = logged?.user?.user?.id;
      const userData = logged?.user?.user;

      // ✅ ถ้าไม่มี token หรือ token ว่าง หรือหมดอายุ → กลับไป login
      if (!token || token === '' || isTokenExpired(token)) {
        navigate('/login');
        return;
      }

      // เซ็ตข้อมูลผู้ใช้ไว้ใน state
      setUser(userData);

      // ✅ ดึง avatar (ภาพล่าสุด) จาก backend
      const fetchLatestApplication = async () => {
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_API}/application/latest/${userId}`,
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );
          if (data?.path) {
            setAvatarPath(data.path);
          }
        } catch (error) {
          console.error('Failed to fetch latest application:', error);
          setAvatarPath(null);
        }
      };

      fetchLatestApplication();
    } catch (error) {
      console.error('Error parsing logged user from localStorage:', error);
      navigate('/login');
    }
  }, [navigate]);

  // ✅ ฟังก์ชันออกจากระบบ
  const handleSignOut = () => {
    localStorage.removeItem('logged');
    navigate('/login');
  };

  // ถ้าไม่มีข้อมูลผู้ใช้เลย → ไม่ต้อง render อะไร
  if (!localStorage.getItem('logged')) {
    return null;
  }

  return (
    <Container>
      {/* แสดงแบนเนอร์ด้านบน */}
      <Image src={Banner} fluid />

      {/* Navbar ด้านบน */}
      <Navbar className="shadow-sm rounded" expand="md" bg="light" data-bs-theme="light" variant="light">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* เมนูฝั่งซ้าย */}
          <Nav className="me-auto">
            <NavDropdown
              title="ประวัติส่วนตัว"
              id="nav-profile-dropdown"
              className={location.pathname.startsWith('/profile') ? 'active' : ''}
            >
              <NavDropdown.Item as={Link} to="/profile">ดูประวัติ</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/profile/edit">แก้ไข</NavDropdown.Item>
            </NavDropdown>
            <Link className={`nav-link ${location.pathname === '/profile/education' ? 'active' : ''}`} to="/profile/education">ประวัติการศึกษา</Link>
            <Link className={`nav-link ${location.pathname === '/profile/activities' ? 'active' : ''}`} to="/profile/activities">ประวัติการเข้าร่วมกิจกรรมระหว่างการศึกษา</Link>
            <Link className={`nav-link ${location.pathname === '/profile/counseling' ? 'active' : ''}`} to="/profile/counseling">การขอคำปรึกษา</Link>
            <Link className={`nav-link ${location.pathname === '/profile/career' ? 'active' : ''}`} to="/profile/career">ประวัติทำงาน</Link>
          </Nav>

          {/* เมนูฝั่งขวา (ข้อมูลผู้ใช้) */}
          <Nav className="ms-auto">
            {user && (
              <NavDropdown
                title={
                  <span>
                    {avatarPath && (
                      <img
                        src={`${process.env.REACT_APP_UPLOAD}/${avatarPath}`}
                        alt="Avatar"
                        style={{
                          height: 32,
                          width: 32,
                          objectFit: 'cover',
                          borderRadius: '50%',
                          marginRight: '0.5rem'
                        }}
                        className="rounded-circle me-2"
                      />
                    )}
                    {user.first_name} {user.last_name}
                  </span>
                }
                id="user-nav-dropdown"
                align="end"
              >
                <NavDropdown.Item onClick={handleSignOut}>ออกจากระบบ</NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* render เนื้อหาที่อยู่ภายใต้ <Outlet /> */}
      <Outlet />
    </Container>
  );
};

export default Home;